import { IconListElement, Separator, Text } from "@nju/ui";
import { addPeriodToDate, formatDate } from "@nju/utils";

interface ISidebarOfferBenefitsProps {
  voicePackageAnniversaryDate: number | undefined;
  dataPackageAnniversaryDate: number | undefined;
}

export function SidebarRoamingOfferBenefits({
  voicePackageAnniversaryDate,
  dataPackageAnniversaryDate,
}: ISidebarOfferBenefitsProps) {
  const anniversaryDatePackage = (
    <>
      <Text weight="bold">ważność pakietu</Text>
      {voicePackageAnniversaryDate && (
        <>
          <Separator size="none" tone="invisible" />
          <Text size="s">
            pakiet minut będzie ważny do
            <Separator size="none" tone="invisible" />
            {formatDate(addPeriodToDate(voicePackageAnniversaryDate))}
          </Text>
        </>
      )}
      {dataPackageAnniversaryDate && (
        <>
          <Separator size="none" tone="invisible" />
          <Text size="s">
            pakiet GB będzie ważny do
            <Separator size="none" tone="invisible" />
            {formatDate(addPeriodToDate(dataPackageAnniversaryDate))}
          </Text>
        </>
      )}
    </>
  );

  if (voicePackageAnniversaryDate || dataPackageAnniversaryDate) {
    return (
      <IconListElement
        iconAlign="start"
        iconName="history"
        iconSize="medium"
        mode="raw"
        text={anniversaryDatePackage}
      />
    );
  }

  // eslint-disable-next-line unicorn/no-null
  return null;
}
